import { render, staticRenderFns } from "./LegacyFreight.vue?vue&type=template&id=e74594de&"
import script from "./LegacyFreight.vue?vue&type=script&lang=js&"
export * from "./LegacyFreight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports